function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h30v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.602 15.295c-.786 0-1.528-.31-2.081-.863l-3-3a.569.569 0 0 0-.787 0l-3.011 3.022a2.933 2.933 0 0 1-2.081.863h-.587l3.797 3.795a3.042 3.042 0 0 0 4.296 0l3.808-3.806h-.354v-.011zM9.642 4.683c.786 0 1.527.31 2.08.863l3.012 3.01a.548.548 0 0 0 .786 0l3-2.999a2.933 2.933 0 0 1 2.082-.863h.365L17.147.888a3.042 3.042 0 0 0-4.295 0L9.055 4.683h.587z",
  fill: "#8D5765",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.112 7.848-2.303-2.302a.444.444 0 0 1-.166.034H20.59c-.543 0-1.074.22-1.45.597l-3 2.999c-.277.276-.654.42-1.02.42-.365 0-.741-.144-1.018-.42l-3.011-3.01a2.044 2.044 0 0 0-1.45-.598H8.357a.354.354 0 0 1-.155-.033L5.888 7.848a3.037 3.037 0 0 0 0 4.293l2.314 2.313a.354.354 0 0 1 .155-.034h1.285c.542 0 1.073-.22 1.45-.597l3.011-3.01c.543-.542 1.495-.542 2.037 0l3 2.999c.388.387.908.597 1.45.597h1.053c.055 0 .11.011.166.034l2.303-2.302a3.037 3.037 0 0 0 0-4.293",
  fill: "#8D5765",
  fillRule: "nonzero"
}));

function SvgIconPix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPix);
export default __webpack_public_path__ + "static/media/icon-pix.d33e3d7d.svg";
export { ForwardRef as ReactComponent };